const current_year = new Date().getFullYear();

// if param year = current_year: the order will be
// detailYear = current year,
// one_year_difference = detailYear - 1 = detailOneYearAgo
// two_year_difference = detailYear - 2 = detailTwoYearAgo

export const is_search_year_current_year = (year) => {
  return Number(year) === current_year;
};

// if param year = current_year - 1: the order will be
// detailYear = current_year - 1,
// one_year_difference = detailYear + 1 = detailOneYearAgo
// two_year_difference = detailYear - 1 = detailTwoYearAgo

export const is_search_year_last_year = (year) => {
  return Number(year) === current_year - 1;
};

// if param year <= current_year - 2: the order will be
// detailYear = current_year - 2,
// one_year_difference = detailYear + 1 = detailOneYearAgo
// two_year_difference = detailYear + 2 = detailTwoYearAgo

export const is_search_year_2_years_ago = (year) => {
  return Number(year) <= current_year - 2;
};
